import { render } from "./ItemContainer.vue?vue&type=template&id=fe8ab664&scoped=true&ts=true"
import script from "./ItemContainer.vue?vue&type=script&lang=ts"
export * from "./ItemContainer.vue?vue&type=script&lang=ts"

import "./ItemContainer.vue?vue&type=style&index=0&id=fe8ab664&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8ab664"]])

export default __exports__